// Search Arrays of objects
const search = (nameKey, myArray, k) => {
    for (var i=0; i < myArray.length; i++) {
      if (myArray[i][k] === nameKey) {
        return myArray[i];
      }
    }
  }

export default(search)